import { Component, inject, input } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { OrganizationSidebarLayout } from '../../../organizations/components/organization-sidebar-layout/organization-sidebar-layout';
import { PageHeader } from '../../../layout/components/page-header/page-header';
import { PageTitle } from '../../../layout/components/page-title/page-title';
import { BreadcrumbNavSkeleton } from '../../../../shared/components/breadcrumb-nav-skeleton/breadcrumb-nav-skeleton';
import { SettingsBreadcrumbNav } from '../../components/settings-breadcrumb-nav/settings-breadcrumb-nav';
import { OrganizationsStore } from '../../../organizations/store/organizations.store';
import { NavSkeleton } from '../../../../shared/components/nav-skeleton/nav-skeleton';
import { SettingsNav } from '../../components/settings-nav/settings-nav';
import { ErrorPage } from '../../../../shared/components/error-page/error-page';

@Component({
  imports: [
    RouterOutlet,
    OrganizationSidebarLayout,
    PageHeader,
    PageTitle,
    BreadcrumbNavSkeleton,
    SettingsBreadcrumbNav,
    NavSkeleton,
    SettingsNav,
    ErrorPage,
    TranslocoPipe,
  ],
  templateUrl: './settings-page.html',
})
export class SettingsPage {
  protected router = inject(Router);

  private organizationsStore = inject(OrganizationsStore);
  protected state = this.organizationsStore.selected;

  organizationId = input.required<string>();
}
